import { render, staticRenderFns } from "./player.vue?vue&type=template&id=437b4eb8&scoped=true&"
import script from "./player.vue?vue&type=script&lang=ts&"
export * from "./player.vue?vue&type=script&lang=ts&"
import style0 from "./player.vue?vue&type=style&index=0&id=437b4eb8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b4eb8",
  null
  
)

export default component.exports